 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import {useMemo} from 'react'
import {readInlineData} from 'react-relay'


const useGetUsedServiceTaskIds = (phaseRef) => {
  return useMemo(() => {
    const estimatePhase = readInlineData(
      graphql`
        fragment useGetUsedServiceTaskIds_phase on EstimatePhase @inline {
          stages {
            taskId
            task {
              integrationHash
            }
          }
        }
      `,
      phaseRef
    )
    const {stages} = estimatePhase
    const usedServiceTaskIds = new Set()
    stages.forEach((stage) => {
      const {task, taskId} = stage
      const serviceTaskId = _nullishCoalesce(_optionalChain([task, 'optionalAccess', _ => _.integrationHash]), () => ( taskId))
      // a new serviceTaskId uniquely identifies an issue that doesn't exist in our system yet (integrationHash)
      usedServiceTaskIds.add(serviceTaskId)
    })
    return usedServiceTaskIds
  }, [phaseRef])
}

export default useGetUsedServiceTaskIds
